<template>
  <div>
    <portlet
      :icon="'fas fa-question-circle'"
      :title="''"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20"
    >
      <template slot="actionsBlock">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <i class="fas fa-long-arrow-left mr-2"></i> Back
        </button>
      </template>

      <template slot="portletBody">
        <uwesForm :uwesId="uwesId"/>
      </template>
    </portlet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import uwesForm from "@/components/engagement/forms/uwesForm.vue";

export default {
  name: "uwes",
  props: [],
  mixins: [],
  components: {
    uwesForm,
  },
  data() {
    return {
      user: null,
      uwesId: null
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),
    ...mapGetters("userData", ["getMyDepartments"]),
    ...mapGetters("users", ["getMe", "getClaims"]),
  },
  async created() {
    this.checkPermisisons();
  },
  methods: {
    checkPermisisons() {
      this.uwesId = this.$route.params.userId;
      const claims = this.getClaims;
      if (this.uwesId === this.getMe.id || claims.admin === true || claims.teamlead === true) {
      } else {
        console.log("access denied, rerouting to own survey");
        this.$router.push({ name: "uwes", params: { userId: this.getMe.id } });
      }
    },
  },
  watch: {
    "$route.params.userId"(newVal, oldVal) {
      this.checkPermisisons();
    },
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>
